import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export function LandingHeader() {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-lg border-b border-border/40">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <img 
              src="/logo.png" 
              alt="Clan" 
              className="h-8 w-auto"
            />
          </Link>

          {/* Auth Buttons */}
          <div className="flex items-center gap-3">
            <a href="https://ba50b1f8-f14c-49af-a793-05a9c8062d5c.lovableproject.com/auth">
              <Button variant="ghost" size="sm">
                Connexion
              </Button>
            </a>
            <a href="https://ba50b1f8-f14c-49af-a793-05a9c8062d5c.lovableproject.com/auth">
              <Button size="sm" className="bg-primary hover:bg-primary/90">
                Commencer
              </Button>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
